import React from 'react';

/**
 * Bibliothèque de composants UI Premium — implémente le design system
 * park4night (voir park4night Design System/README.md). Le style vit dans
 * premium-ui.css, construit sur les tokens de colors_and_type.css.
 */

const ASSETS = '/assets/ds';

export function Button({ variant = 'primary', size, block, icon, children, ...props }) {
    const classes = ['btn', `btn--${variant}`];
    if (size) classes.push(`btn--${size}`);
    if (block) classes.push('btn--block');
    return (
        <button className={classes.join(' ')} {...props}>
            {icon && <img className="btn__icon" src={`${ASSETS}/icons/${icon}.svg`} alt="" />}
            {children}
        </button>
    );
}

export function Card({ children, className = '', ...props }) {
    return <section className={`card ${className}`} {...props}>{children}</section>;
}

export function Tag({ variant, children }) {
    return <span className={`tag${variant ? ` tag--${variant}` : ''}`}>{children}</span>;
}

/** Titre de section avec le divider mint dashed signature du DS */
export function SectionTitle({ children }) {
    return (
        <>
            <h2 className="section-title">{children}</h2>
            <hr className="dashed-divider" />
        </>
    );
}

export function Field({ label, hint, error, children }) {
    return (
        <div className="field">
            {label && <label className="field__label">{label}</label>}
            {children}
            {hint && !error && <div className="field__hint">{hint}</div>}
            {error && <div className="field__error">{error}</div>}
        </div>
    );
}

export function Input({ invalid, ...props }) {
    return <input className={`input${invalid ? ' is-invalid' : ''}`} {...props} />;
}

export function Textarea({ invalid, ...props }) {
    return <textarea className={`textarea${invalid ? ' is-invalid' : ''}`} {...props} />;
}

export function Select({ children, ...props }) {
    return <select className="select" {...props}>{children}</select>;
}

export function Rating({ value }) {
    return (
        <span className="rating">
            <img src={`${ASSETS}/icons/star_blue.svg`} alt="" />
            {value != null ? Number(value).toFixed(1) : '—'}
        </span>
    );
}

export function Avatar({ src, name }) {
    if (src) return <img className="avatar" src={src} alt={name || ''} />;
    return <span className="avatar avatar--placeholder">{(name || '?').slice(0, 2)}</span>;
}

export function Spinner() {
    return <div className="spinner" role="status" aria-label="loading" />;
}

export function EmptyState({ children }) {
    return <div className="empty-state">{children}</div>;
}

export function Modal({ open, onClose, children }) {
    if (!open) return null;
    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
                {children}
            </div>
        </div>
    );
}

export function Flash({ type = 'success', children }) {
    return <div className={`flash flash--${type}`}>{children}</div>;
}
